import { u7proOutdoor } from '../u7proOutdoor.mjs';
"use strict";
const u7proOutdoorOverviewVariant = {
  ...u7proOutdoor,
  notes: ["u7proOutdoor.notes.1"]
};
export { u7proOutdoorOverviewVariant };
//# sourceMappingURL=u7proOutdoorOverviewVariant.mjs.map
